if (!customElements.get("icons-slider")) {
  customElements.define(
    "icons-slider",
    class IconsSlider extends HTMLElement {
      constructor() {
        super();
        this._innit();
      }
      getScrollAmount() {
        return window.innerWidth >= 768 ? 212 : 99;
      }
      _innit() {
        this.querySelectorAll(".icons__slider--container").forEach((slider) => {
          const leftArrow = slider.querySelector(".scroll-btn.left");
          const rightArrow = slider.querySelector(".scroll-btn.right");
          const iconsSliderList = slider.querySelector(".icons__slider-list");

          if (!leftArrow || !rightArrow || !iconsSliderList) {
            console.error("One or more elements are missing inside a slider.");
            return;
          }

          // Local arrow function to handle visibility logic
          const updateArrowVisibility = () => {
            const hasScroll =
              iconsSliderList.scrollWidth > iconsSliderList.clientWidth;
            leftArrow.style.display = rightArrow.style.display = hasScroll
              ? "flex"
              : "none";
          };

          // Scroll event listener
          iconsSliderList.addEventListener("scroll", updateArrowVisibility);
          window.addEventListener("resize", updateArrowVisibility);

          // Click event listeners for arrows
          leftArrow.addEventListener("click", () => {
            iconsSliderList.scrollBy({
              left: -this.getScrollAmount(),
              behavior: "smooth",
            });
          });

          rightArrow.addEventListener("click", () => {
            iconsSliderList.scrollBy({
              left: this.getScrollAmount(),
              behavior: "smooth",
            });
          });

          // Initial check to set arrow visibility
          updateArrowVisibility();
        });
      }
    }
  );
}
